import React from 'react';
import styled from 'styled-components';
import { bodySmall, header4 } from '../styles/text';

const TextBlockContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  align-items: center;
  max-width: 525px;
  padding: 0 1rem;
  margin: 75px auto 0.5rem;
  text-align: center;
`;

const PrimaryText = styled.div`
  ${header4}
`;

const SecondaryText = styled.div`
  ${bodySmall}
  color: ${({ theme }) => theme.colors.gray666};
`;

type TextBlockProps = {
  primaryText: string;
  secondaryText?: string;
};

export function TextBlock({ primaryText, secondaryText }: TextBlockProps) {
  return (
    <TextBlockContainer>
      <PrimaryText>{primaryText}</PrimaryText>
      {secondaryText && <SecondaryText>{secondaryText}</SecondaryText>}
    </TextBlockContainer>
  );
}
